// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  origin: 'https://dev-km.set.or.th',
  apiBasePath: window.origin + '/api',
  tenant: '7cf70668-de90-4e0a-bdc1-42dd27fc4aee',
  clientId: '98cd6594-454b-46cf-ad65-0a86553952b1',
  basicAuthenticationCode: 'ZGlwLWd3OmRpcC02MGIyNzY2MWM=',
  dipPortalUrl: 'https://dev.dipgw.set.or.th'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
